import Store from '@/store';
import { appMixins } from '@/mixins';
import i18n from '@/translations';

const RESET_CODE_TEMP_PATH = '/password/reset-code';

export default ({
	run: (to, from, next) => {
		if (to.path === RESET_CODE_TEMP_PATH) {
			const resetToken = appMixins.getParameterFromUrl('code');
			const language = appMixins.getParameterFromUrl('lang');
			const email = appMixins.getParameterFromUrl('email');

			if (
				language == null
				|| Object.keys(i18n.messages).indexOf(language) === -1
				|| resetToken == null
				|| email == null
			) {
				next({ name: 'default' });
				return true;
			}
			i18n.locale = language;

			const redirectToForgotPassword = () => {
				const forgotPasswordError = {
					title: i18n.messages[language]['reset-password']['title-invalid-link'],
					description: i18n.messages[language]['reset-password']['invalid-link'],
				};
				Store.dispatch('application/SET_PROPERTY', { forgotPasswordError });
				next({ name: `forgot-password-${language}` });
			};

			Store.dispatch('sso/VALIDATE_RESET_TOKEN', resetToken)
				.then((response) => {
					const { data } = response.data;
					if (data.found) {
						Store.dispatch('application/SET_RESET_TOKEN_AND_EMAIL', {
							resetToken,
							email: appMixins.getParameterFromUrl('email'),
						})
							.then(() => {
								const resetInfo = {
									email,
									lang: language,
									code: resetToken,
								};
								Store.dispatch('application/SET_PROPERTY', { resetInfo }).then(() => {
									next({ name: `reset-password-${language}` });
								});
							})
							.catch(() => { next({ name: `login-${language}` }); });
					} else {
						redirectToForgotPassword();
					}
				})
				.catch(() => {
					redirectToForgotPassword();
				});
			return true;
		}
		return false;
	},
});
